
export class Cookie {
	public static get(name: string, environment?: string): string {
		const r = new RegExp(`(^| )${name}=([^;]+)`, 'g')
		let cookieMatches = document.cookie.match(r)

		if (!cookieMatches || !cookieMatches.length) {
			return ''
		}

		// If we have more than one cookie, and environment value is available
		if (cookieMatches.length > 1 && environment) {
			// Get the cookie that matches the environment
			let tempMatches = cookieMatches.filter((c) => {
				const tokens = atob(decodeURIComponent(c.replace(`${name}=`, ''))).split(' ')
				if (tokens[2]) {
					return tokens[2] === environment
				}
				return false
			})

			// If we didn't find one then take all
			if (!tempMatches?.length) {
				tempMatches = cookieMatches
			}

			cookieMatches = tempMatches
		}

		const c = cookieMatches[0].trim()
		if (c) {
			const val = decodeURIComponent(c).replace(`${name}=`, '')
			return val
		}
		return ''
	}

	public static set(name: string, value: string, opts = {}): void {
		opts = Object.entries(opts).reduce((str, [k, v]) => `${str}; ${k}=${v}`, '')
		document.cookie = name + '=' + encodeURIComponent(value) + opts
	}

	public static delete(name: string, opts: Record<string, unknown> = {}): void {
		Cookie.set(name, '', { 'max-age': -1, ...opts })
	}

	public static deleteAll(): void {
		const allCookies = document.cookie.split(';')

		for (let i = 0; i < allCookies.length; i++) {
			const name = allCookies[i].split('=')[0]
			Cookie.set(name, '', { 'max-age': -1, 'expires': new Date(0).toUTCString() })
		}
	}

	public static deleteMarketing(): void {
		const allCookies = document.cookie.split(';')

		for (let i = 0; i < allCookies.length; i++) {
			const name = allCookies[i].split('=')[0]
			if (name.includes('lynx')) continue
			Cookie.set(name, '', { 'max-age': -1, 'expires': new Date(0).toUTCString() })
		}
	}

	public static log(): void {
		const allCookies = document.cookie.split(';')

		for (let i = 0; i < allCookies.length; i++) {
			console.log(allCookies[i])
		}
	}
}

(window as any).cookie = Cookie
